import React from "react";
import { t } from "ttag";

export const BasketLineQuantity = (props: {
    quantity: number;
}): React.ReactNode => {
    return (
        <div className="basket-line__details__qty">
            <p>
                {t`Qty:`} {props.quantity}
            </p>
        </div>
    );
};
